import * as React from 'react';

const PrequalPending: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'>
			<circle cx='8' cy='8' r='6.5' stroke='#CCCCCC' />
		</svg>
	);
};

export default PrequalPending;
